module.exports = __webpack_public_path__ + "static/media/allImg.24b30e4b.png";